import React from "react";
import AppLayout from "../components/AppLayout";
import Footer from "../components/Footer";
import Ligas from "../components/Ligas"; // novo componente
import "./Dashboard.css";

export default function Dashboard() {
  const ligasDisponiveis = [
    { nome: "Premier League", flag: "/assets/premier.png" },
    { nome: "La Liga", flag: "/assets/laliga.png" },
    { nome: "Serie A", flag: "/assets/seriea.png" },
    { nome: "Bundesliga", flag: "/assets/bundesliga.png" },
  ];

  return (
    <AppLayout>
      <section className="dashboard-header">
        <h1>INTELIGÊNCIA DE DADOS.<br />VANTAGEM EM CADA JOGO.</h1>
        <p>
          Escaneamos milhares de dados em tempo real para identificar as melhores
          oportunidades nos esportes.
        </p>
        <div className="dashboard-buttons">
          <button>Ver Oportunidades</button>
          <button>Ver Scanner Ao Vivo</button>
        </div>
      </section>

      {/* Ligas em linha */}
      <Ligas ligas={ligasDisponiveis} />

      {/* Cards explicativos */}
      <section className="dashboard-cards">
        <div className="card">
          <h3>📊 Nosso Foco</h3>
          <p>
            Decisão inteligente começa com dados. Unimos análise quantitativa,
            métricas proprietárias e modelagem estatística.
          </p>
        </div>
        <div className="card">
          <h3>🎯 Resultados Esperados</h3>
          <p>
            Mais agilidade e consistência na análise de jogos, com dados
            atualizados em tempo real e leitura de padrões estatísticos.
          </p>
        </div>
        <div className="card">
          <h3>⚙️ Indicadores Proprietários</h3>
          <p>
            Indicadores exclusivos que combinam estatísticas ofensivas,
            defensivas e padrões comportamentais das equipes.
          </p>
        </div>
        <div className="card">
          <h3>🔒 Dados Confiáveis</h3>
          <p>
            Base sólida de informações para apoiar decisões estratégicas com
            transparência e responsabilidade.
          </p>
        </div>
      </section>

      <Footer />
    </AppLayout>
  );
}
